import React, { useState, useEffect } from 'react'
import { loadStripe } from '@stripe/stripe-js'
import { FlexboxGrid, IconButton, Modal } from 'rsuite'
import styled from 'styled-components'
import { colors, fonts } from '../Components/Styles/common-styles'
import { PurpleDeleteIcon, SuccessCheck } from '../Components/Icons'
import { useHistory } from 'react-router-dom'
import { addStripePayment, getUsersCollection } from '../Context/firebase'

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY)
const PayButton = styled.button`
  margin: auto;
  background: ${colors.purpleBright};
  font-weight: 600;
  font-size: ${fonts.normalSize};
  line-height: 18px;
  color: #fff;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 11px 18px;
  &:hover {
    background: ${colors.purpleMain};
  }
`
const SubCard = styled.div`
  background: ${colors.highlighter};
  border: 1px solid ${colors.purpleMain};
  box-sizing: border-box;
  border-radius: 8px;
  width: 270px;
  min-height: 420px;
  display: flex;
  justify-content: center;
  flex-direction: column;
`

const Image = styled.img`
  width: auto;
  height: 134px;
  margin: auto;
`
const PlanTitle = styled.h2`
  font-weight: 600;
  font-size: ${fonts.bigSize};
  color: ${colors.black};
  line-height: 130%;
  margin: auto;
`

const PlanText = styled.p`
  font-size: ${fonts.normalSize};
  color: ${colors.black};
  line-height: 130%;
  margin: auto;
  text-align: center;
`

const Price = styled.span`
  font-weight: 500;
  line-height: 33px;
  font-size: ${fonts.extraLargePlusSize};
  color: ${colors.pink};
  text-align: center;
`
const PriceText = styled.span`
  line-height: 14px;
  font-size: ${fonts.normalSize};
  color: ${colors.grey};
  text-align: center;
  vertical-align: sub;
`
const Icon = styled.span`
  font-size: ${fonts.bigSize};
  color: ${colors.pink};
  vertical-align: super;
`

const Plan = ({ handleClick, paid }) => (
  <FlexboxGrid style={{ margin: '2%' }}>
    <SubCard>
      <Image
        src='/images/Book-icon.svg'
        alt='Taito'
      />
      <PlanTitle>Basic</PlanTitle>
      <PlanText>A simple start for everyone</PlanText>
      <div style={{ display: 'inline-flex', justifyContent: 'center' }}>
        <Icon>€</Icon>
        <Price>5 </Price>
        <PriceText>/month</PriceText>
      </div>
      <PayButton
        id='checkout-button'
        disabled={paid}
        onClick={handleClick}>
        {!paid ? 'Choose plan' : '\u2714 Your current Plan'}</PayButton>
    </SubCard>
  </FlexboxGrid>

)

const ResultModal = (props) => {
  return (
    <Modal
      show={props.show}
      onHide={props.handleClose}
      style={{ width: '480px', margin: '5% auto' }}
    >
      <Modal.Header style={{ textAlign: 'center' }}>
        <IconButton className='i-button' style={{ height: 'fit-content' }} icon={props.message.icon === 'delete' ? <PurpleDeleteIcon /> : <SuccessCheck />} />
      </Modal.Header>
      <Modal.Body style={{ textAlign: 'center' }}>
        <PlanTitle>{props.message.title}</PlanTitle>
        <PlanText style={{ display: 'block ', maxWidth: '614px', margin: '5% auto', textAlign: 'center', lineHeight: '34.2px', fontSize: fonts.largePlusSize }}>
          {props.message.message}
        </PlanText>
      </Modal.Body>
    </Modal>
  )
}

export default function SubscriptionPlan () {
  const [message, setMessage] = useState('')
  const [showModal, setModal] = useState(false)
  const [paid, setPaid] = useState(false)

  const history = useHistory()

  const hideModal = () => {
    setModal(false)
    history.push('/settings')
  }
  // get payment data from firebase
  useEffect(() => {
    const getUserData = async () => {
      try {
        const usersCollection = await getUsersCollection()
        setPaid(usersCollection.paid)
        console.log(usersCollection.paid)
        return usersCollection
      } catch (err) {
        console.error(err)
      }
    }
    getUserData()
  }, [paid, showModal])

  // saving payment data to firebase
  useEffect(() => {
    const savePayment = async () => {
      try {
        await addStripePayment(paid)
      } catch (err) {
        console.error(err)
      }
    }
    paid && savePayment()
  }, [paid])

  useEffect(() => {
    // Check to see if this is a redirect back from Checkout
    const query = new URLSearchParams(window.location.search)
    console.log(query.get('active'))
    if (query.get('success')) {
      setMessage({
        title: 'Payment successful!',
        message: 'Thank you, the payment went through. ',
        icon: 'success'
      })
      setPaid(true)
      setModal(true)
    }

    if (query.get('canceled')) {
      setMessage({
        title: 'Oh no! Something went wrong.',
        message: 'We aren’t able to process your payment. Please, try again.',
        icon: 'delete'
      })
      setModal(true)
    }
  }, [showModal])

  const handleClick = async (event) => {
    const stripe = await stripePromise
    const response = await fetch('https://us-central1-taito-training.cloudfunctions.net/createStripeCheckout', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        priceId: 5
      })
    })
    const session = await response.json()
    // When the customer clicks on the button, redirect them to Checkout.
    const result = await stripe.redirectToCheckout({
      sessionId: session.id
    })

    if (result.error) {
      // If `redirectToCheckout` fails due to a browser or network
      // error, display the localized error message to your customer
      // using `result.error.message`.
    }
  }

  return (
    <>
      <ResultModal
        show={showModal}
        message={message}
        handleClose={hideModal}
      />
      <Plan handleClick={handleClick} paid={paid} />
    </>
  )
}
